export enum SingleTopicType {
    NextStepsConsult = 'NextStepsConsult',
    TobaccoFree = 'TobaccoFree',
    Onsite = 'Onsite'
}
